import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3c42bf64")

_pushScopeId("data-v-3c42bf64")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Rapportini")
const _hoisted_2 = {
  key: 0,
  class: "loading_spinner"
}
const _hoisted_3 = {
  key: 1,
  class: "page_content"
}
const _hoisted_4 = { class: "nuovo_intervento" }
const _hoisted_5 = {
  key: 0,
  class: "no_interventi_container"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "no_interventi" }, "Nessun rapportino creato", -1)
const _hoisted_7 = {
  key: 1,
  class: "container_interventi"
}
const _hoisted_8 = {
  key: 0,
  class: "counters"
}
const _hoisted_9 = { class: "single_counter" }
const _hoisted_10 = { class: "total_hour" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "title" }, "Mese precedente", -1)
const _hoisted_12 = { class: "single_counter" }
const _hoisted_13 = { class: "total_hour" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "title" }, "Mese corrente", -1)
const _hoisted_15 = {
  key: 1,
  class: "counters"
}
const _hoisted_16 = { class: "single_counter" }
const _hoisted_17 = { class: "total_hour" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "title" }, "Ore previste", -1)
const _hoisted_19 = { class: "single_counter" }
const _hoisted_20 = { class: "total_hour" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "title" }, "Ore effettuate", -1)
const _hoisted_22 = { class: "date" }
const _hoisted_23 = { class: "customer" }
const _hoisted_24 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_buttons = _resolveComponent("ion-buttons")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_title, { color: "white" }, {
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openMenu())),
                slot: "start"
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.menu,
                        slot: "start"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.loadRapportini()))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "start",
                        icon: $setup.refresh,
                        color: "white"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          ($setup.loading)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _createVNode(_component_ion_spinner, {
                  name: "crescent",
                  color: "dark"
                })
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, [
                  _createVNode("button", {
                    class: "intervento_button",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.openNuovoRapportino && $setup.openNuovoRapportino(...args)))
                  }, "Nuovo rapportino")
                ]),
                (!$setup.rapportini.length)
                  ? (_openBlock(), _createBlock("div", _hoisted_5, [
                      _hoisted_6
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_7, [
                      ($setup.mostra_counters_rapportini)
                        ? (_openBlock(), _createBlock("div", _hoisted_8, [
                            _createVNode("div", _hoisted_9, [
                              _createVNode("div", _hoisted_10, _toDisplayString($setup.totalMesePrecedente.toFixed(2)) + " ore", 1),
                              _hoisted_11
                            ]),
                            _createVNode("div", _hoisted_12, [
                              _createVNode("div", _hoisted_13, _toDisplayString($setup.totalMeseCorrente.toFixed(2)) + " ore", 1),
                              _hoisted_14
                            ])
                          ]))
                        : (_openBlock(), _createBlock("div", _hoisted_15, [
                            _createVNode("div", _hoisted_16, [
                              _createVNode("div", _hoisted_17, _toDisplayString($setup.totalOrePreviste.toFixed(2)) + " ore", 1),
                              _hoisted_18
                            ]),
                            _createVNode("div", _hoisted_19, [
                              _createVNode("div", _hoisted_20, _toDisplayString($setup.totalMeseCorrente.toFixed(2)) + " ore", 1),
                              _hoisted_21
                            ])
                          ])),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.rapportini, (rapportino) => {
                        return (_openBlock(), _createBlock("div", {
                          class: "intervento",
                          key: rapportino.rapportini_id,
                          onClick: ($event: any) => ($setup.openDetail(rapportino))
                        }, [
                          _createVNode("div", _hoisted_22, [
                            _createVNode("span", null, _toDisplayString($setup.dateFormat(rapportino.rapportini_data)) + ", ", 1),
                            _createVNode("span", null, _toDisplayString(rapportino.rapportini_ora_inizio + " - " + rapportino.rapportini_ora_fine), 1)
                          ]),
                          _createVNode("div", _hoisted_23, [
                            _createVNode("span", null, _toDisplayString($setup.riferimentoCliente(rapportino)), 1),
                            (rapportino.rapportini_commessa)
                              ? (_openBlock(), _createBlock("span", _hoisted_24, _toDisplayString(rapportino.projects_name), 1))
                              : _createCommentVNode("", true)
                          ])
                        ], 8, ["onClick"]))
                      }), 128))
                    ]))
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})